import React from 'react';
import { VC_ASSETS } from './assets/assets.js';
import './index.css';
import Campus from './hero/index.jsx'
import Footer from '../About/Footer';
import { Link } from 'react-router-dom';
const VirtualCampus = () => {
  return (
    <div className="vc-component-wrapper">
      
      {/* 1. Hero Section */}
      <section 
        className="vc-hero-section" 
        style={{ backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.4)), url(${VC_ASSETS.hero})` }}
      >
        <div className="vc-hero-container">
          <div className="vc-hero-content">
            <h1 className="vc-hero-title">
              Welcome to our Virtual Startup <br />
              Campus initiative to promote <br />
              Job Readiness & Startup
            </h1>
            <div className="vc-hero-underline"></div>
          </div>
        </div>
      </section>

      {/* 2. NEW: Explore Opportunities Banner */}

      <section className="vc-about-section">
        <div className="vc-container">
          <div className="vc-header">
            <h2 className="vc-main-title">What is Virtual Startup Campus?</h2>
            <p className="vc-subtitle">
              A platform accessible from anywhere, that helps you <br />
              learn practical skills for various new career choices
            </p>
          </div>

          <div className="vc-grid">
            {/* Card 1: Access */}
            <div 
              className="vc-card" 
              style={{ backgroundImage: `linear-gradient(to top, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.2) 60%, rgba(0,0,0,0) 100%), url(${VC_ASSETS.access})` }}
            >
              <img src={VC_ASSETS.access} style={{ display: 'none' }} loading="lazy" alt="" />
              <div className="vc-card-content">
                <h3 className="vc-card-title">Access from Anywhere</h3>
                <p className="vc-card-desc">You can access the skills and learning journey from anywhere</p>
              </div>
            </div>

            {/* Card 2: Skill */}
            <div 
              className="vc-card" 
              style={{ backgroundImage: `linear-gradient(to top, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.2) 60%, rgba(0,0,0,0) 100%), url(${VC_ASSETS.skill})` }}
            >
              <img src={VC_ASSETS.skill} style={{ display: 'none' }} loading="lazy" alt="" />
              <div className="vc-card-content">
                <h3 className="vc-card-title">In Demand Skills</h3>
                <p className="vc-card-desc">Skill taught are top rated and in demand in the market</p>
              </div>
            </div>

            {/* Card 3: Hands On */}
            <div 
              className="vc-card" 
              style={{ backgroundImage: `linear-gradient(to top, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.2) 60%, rgba(0,0,0,0) 100%), url(${VC_ASSETS.handson})` }}
            >
              <img src={VC_ASSETS.handson} style={{ display: 'none' }} loading="lazy" alt="" />
              <div className="vc-card-content">
                <h3 className="vc-card-title">Hands On Methodology</h3>
                <p className="vc-card-desc">The method in which skills are taught are hands on and practical approach</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Campus />
      <section 
        className="vc-explore-banner"
        style={{ backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(${VC_ASSETS.exploreBg})` }}
      >
        <div className="vc-container vc-explore-flex">
          <div className="vc-explore-text-box">
            <h2 className="vc-explore-title">
              Explore the Opportunities in <br />
              Virtual Learning and <br />
              Widespread Connectivity
            </h2>
            <div className="vc-explore-underline"></div>
          </div>
          
          <div className="vc-explore-action">
            <a 
              href={process.env.REACT_APP_VSC_URL}
              target="_blank" 
              rel="noopener noreferrer"
              style={{ textDecoration: 'none' }}
            >
              <button className="vc-arrow-button">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round">
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </button>
            </a>
            
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default VirtualCampus;